/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnLeftUpIcon16Light = forwardRef('ArrowDUturnLeftUpIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M.126 6.168a.5.5 0 1 0 .748.664L4 3.315V8.5a5.5 5.5 0 0 0 11 0v-4a.5.5 0 0 0-1 0v4a4.5 4.5 0 1 1-9 0V3.315l3.126 3.517a.5.5 0 0 0 .748-.664L5.62 2.508a1.5 1.5 0 0 0-2.242 0L.126 6.169Z" })));
});
